import { Component, TemplateRef, ChangeDetectorRef } from '@angular/core';
import { BaseComponent } from '../base/base.component';
import { TranslateService } from '@ngx-translate/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { Picture } from 'src/models/picture';
import { PictureService } from 'src/services/picture.service';
import { AuthService } from 'src/services/guard/auth.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { ConfirmationService } from 'primeng/api';
import { DeviceDetectorService } from 'ngx-device-detector';

@Component({
  selector: 'app-pictures',
  templateUrl: './pictures.component.html',
  styleUrls: ['./pictures.component.scss']
})
export class PicturesComponent extends BaseComponent {
  pictureModel: Picture;
  modalRef: BsModalRef;
  loadingPictureSave: boolean;

  currentCategory: PictureCategories;
  PictureCategories = PictureCategories;
  isPreview: boolean;

  pictures: Observable<Picture[]>;

  constructor(
    translate: TranslateService,
    private router: Router,
    protected pictureService: PictureService,
    route: ActivatedRoute,
    authService: AuthService,
    private modalService: BsModalService,
    private cd: ChangeDetectorRef,
    private toast: ToastrService,
    private confirm: ConfirmationService,
    deviceDetectorService: DeviceDetectorService
  ) {
    super(translate, authService, deviceDetectorService, route);
    this.currentCategory = route.snapshot.params.id;
    this.pictures = this.pictureService._picturesCast;
    this.pictureService.previewCast.subscribe(p => this.isPreview = p);
    this.getPictures();
  }

  getPictures() {
    this.loadingPictureSave = false;
    this.pictureService.getPicturesByCategory(this.currentCategory);
  }

  switchCategory(cat: PictureCategories) {
    this.currentCategory = cat;
    this.router.navigate([`/pictures/${cat}`], { replaceUrl: true }).then(
      () => this.getPictures()
    );
  }

  preview(id: string) {
    this.pictureService.getCurrentPicture(id);
    this.pictureService.preview();
  }

  //#region ADMIN
  editPicture(picture: Picture, template: TemplateRef<any>) {
    this.pictureModel = new Picture();
    Object.assign(this.pictureModel, picture);
    this.pictureModel.file = null;
    this.modalRef = this.modalService.show(template);
  }

  deletePicture(picture: Picture) {
    this.confirm.confirm({
      message: 'Are you sure?',
      accept: () => {
        this.pictureService.deletePicture(picture, () => {
          this.modalRef.hide();
          this.ngOnInit();
        });
      }
    });
  }

  savePicture() {
    if (!this.pictureModel.id) {
      this.loadingPictureSave = true;
      this.pictureModel.categoryId = this.currentCategory;
      this.pictureService.addPicture(this.pictureModel,
        progress => { },
        () => {
          this.modalRef.hide();
          this.getPictures();
          this.toast.success('Picture Saved!');
        });
    } else {
      this.pictureService.updatePicture(this.pictureModel,
        () => {
          this.getPictures();
          this.modalRef.hide();
          this.toast.success('Picture Updated!');
        }
      );
    }
  }

  onFileChange(event) {
    const reader = new FileReader();

    if (event.target.files && event.target.files.length) {
      const [file] = event.target.files;
      reader.readAsBinaryString(file);
      reader.onload = () => {
        this.pictureModel.file = <File>file;
        // need to run CD since file load runs outside of zone
        this.cd.markForCheck();
      };
    }
  }
  //#endregion

}

enum PictureCategories {
  Villa = '40000000-0000-0000-0000-000000000001',
  East = '40000000-0000-0000-0000-000000000003',
  Surroundings = '40000000-0000-0000-0000-000000000002'
}
